import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#fec100',
      light: '#fec100',
      dark: '#b68b00ff',
      contrastText: '#ffffff',
    },
    primaryDark: {
      main: '#F5C518',
      light: '#b68b00ff',
      dark: '#977400ff',
      contrastText: '#000000ff',
    },
    primaryDarkHovering: {
      main: '#F5C518',
      light: '#F5C518',
      dark: '#F5C518',
      contrastText: '#000000ff',
    },
    primaryDarkOut: {
      main: '#242424bb',
      light: '#b68b00ff',
      dark: '#977400ff',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#df0a0aff',
      light: '#df0a0aff',
      dark: '#df0a0aff',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ff0000ff',
    },
    warning: {
      main: '#fb5607',
    },
    info: {
      main: '#008bf8',
    },
    success: {
      main: '#00b16a',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#ffffff',
      secondary: '#ffffff',
      disabled: '#ffffff',
    },
  },
    typography: {
    fontFamily: '"Montserrat", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiMenu: {
      styleOverrides: {
          paper: {
              backgroundColor: '#333',
              color: '#fff',
          },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: 'separate',
          borderSpacing: '0 8px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
          padding: '12px 16px',
        },
        head: {
          fontWeight: 600,
          backgroundColor: '#2c3e50',
          color: '#ffffff',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E1E1E', // цвет фона аккордеона
          color: '#ffffffff', // цвет текста
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E1E1E', // цвет заголовка
          '&:hover': {
            backgroundColor: '#2c2c2cff', // цвет при наведении
          },
        },
        content: {
          color: '#ffffffff', // цвет текста заголовка
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          backgroundColor: '#141414ff', // цвет содержимого
          color: '#ffffffff', // цвет текста содержимого
        },
      },
    },
  },
  spacing: 8,
});

export default theme;